import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar'
import { Link } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
export default function UserProfile() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useEffect(() => {


    var userid = localStorage.getItem('member_id');
    console.log('LUID : ' + userid);
    var obj = {
      LUID: userid,
    }
    $.ajax({
      type: 'POST',
      url: 'getUserprofile.php',
      data: obj,
      cache: false,
      success: function (result) {

        if (result !== "fail") {

          var resarr = result;
          console.log(resarr);
          var company_name = resarr[0].company_name;
          var email = resarr[0].email;
          var country = resarr[0].country;
          var phone = resarr[0].phone;
          var expertise = resarr[0].expertise;
          var fname = resarr[0].fname;
          var lname = resarr[0].lname;
          var role = resarr[0].mem_role;
          var skills = resarr[0].mem_skills;
          var member_img = resarr?.[0]?.memberimg ?? 'profile_imgs/no-image-icon-32.jpg';
          var company_logo_img = resarr?.[0]?.companylogo ?? 'profile_imgs/no-image-icon-32.jpg';

          $('#company_name').val(company_name);
          $('#email').val(email);
          $('#country').val(country);
          $('#phone').val(phone);
          $('#expertise').val(expertise);
          $('#skills').val(skills);
          $('#role').val(role);
          $('#fname').val(fname);
          $('#lname').val(lname);
          $('#membername').text(fname + ' ' + lname);
          $('#memimg').attr('src', member_img);
          $('#companyname').text(company_name);
          $('#comlogo').attr('src', company_logo_img);

        } else {
          showAlert('Cannot open company details.');
        }
      },
    });
  }, [])

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function startCloseEdit() {
    var btncaption = $('#editcancel').text();
    if (btncaption === 'Edit') {
      $('#editcancel').text("Cancel Edit");
      $('#editcancel').addClass("cancle_btn");
      $('.profile_update_btn').removeClass('nodisplay')
      $('.openedit').css('display', 'block');
      var idarr = getAllInputFieldIds();
      console.log(idarr)
      var len = idarr.length;
      for (var i = 0; i < len; i++) {
        var trginput = idarr[i];
        $('#' + trginput).addClass('vl_dsh_setBorder');
        $('#' + trginput).removeAttr('readonly');
      }
    } else if (btncaption === 'Cancel Edit') {
      $('#editcancel').text("Edit");
      $('#editcancel').removeClass("cancle_btn");
      $('.profile_update_btn').addClass('nodisplay');
      $('.openedit').css('display', 'none');
      var idarrcancel = getAllInputFieldIds();
      var leng = idarrcancel.length;
      for (var j = 0; j < leng; j++) {
        var trginputcancel = idarrcancel[j];
        $('#' + trginputcancel).removeClass('vl_dsh_setBorder');
        $('#' + trginputcancel).attr('readonly', 'true');
      }
    }
  }

  function getAllInputFieldIds() {
    const inputFields = document.querySelectorAll('#all_fields_holder input');
    const inputFieldIds = Array.from(inputFields).map(input => input.id);
    return inputFieldIds;
  }


  function updateProfile() {
    var userid = localStorage.getItem('member_id');
    var emailval = $('#email').val();
    var company_nameval = $('#company_name').val();
    var country = $('#country').val();
    var fnameval = $('#fname').val();
    var lnameval = $('#lname').val();
    var phone = $('#phone').val();
    var expertise = $('#expertise').val();
    var skills = $('#skills').val();
    var role = $('#role').val();
    if (company_nameval === '') {
      showAlert('Insert your company name');
    } else if (fnameval === '') {
      showAlert('Insert your first name')
    } else if (lnameval === '') {
      showAlert('Insert your last name')
    } else if (emailval === '') {
      showAlert('Insert your email')
    } else {
      var obj = {
        LUID: userid,
        email: emailval,
        fname: fnameval,
        lname: lnameval,
        company_name: company_nameval,
        country: country,
        phone: phone,
        expertise: expertise,
        skills: skills,
        role: role
      }
      $.ajax({
        type: 'POST',
        url: 'updateUserProfile.php',
        data: obj,
        cache: false,
        success: function (result) {
          if (result !== "fail") {
            console.log(result);

          } else {
            showAlert('Cannot Eedit company details.');
          }
        },
      });
    }
  }

  function updateProImg() {
    var userid = localStorage.getItem('member_id');
    const fileInput = document.getElementById('memimg_file');
    if (!fileInput.files.length) {
      showAlert("Please select an image first");
      return;
    }

    const formData = new FormData();
    formData.append('memberimg', fileInput.files[0]);
    formData.append('member_id', userid);
    // 👆 make sure memberId exists (from session / JS variable)

    fetch('updateProfileImage.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          document.getElementById('memimg').src = data.image_url;
          showAlert("Profile image updated successfully");
        } else {
          alert(data.message);
        }
      })
      .catch(err => {
        console.error(err);
        showAlert("Image upload failed");
      });
  }
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <section className='vl_dsh_bodypart_section'>
          <div className='vl_dsh_formnholder mt-50 bigheading editoption'>
            <div className='editbtn_holder'>
              <div className='membersinfoimg'>
                <div className='memberimgholder'>
                  <img id="memimg" />
                </div>
                <h2 id="membername"></h2>
                <div className='imgedit'>
                  <button className='mr-10'>Select Image</button>
                  <input type="file" id="memimg_file" accept="image/*" />
                  <button class="ml-10" id="updateProfileImgBtn" onClick={updateProImg}>Update Profile Image</button>
                </div>

                <button id="editcancel" onClick={startCloseEdit}>Edit</button>
              </div>
            </div>
            <div className='vl_dsh_one_full' id="all_fields_holder">
              <div className='vl_dsh_one_half'>
                <div className='formfieldcommon'>
                  <label>Your Email</label>
                  <input type="text" id="email" placeholder='Insert Email' />
                </div>
                <div className='formfieldcommon'>
                  <label>Your Company Name</label>
                  <input type="text" id="company_name" placeholder='Insert Your Company Name' readOnly />
                </div>
                <div className='formfieldcommon'>
                  <label>Your Country Name</label>
                  <input type="text" id="country" placeholder='Insert Your Country Name' readOnly />
                </div>
                <div className='formfieldcommon'>
                  <label>Phone</label>
                  <input type="text" id="phone" placeholder='Phone' readOnly />
                </div>
                <div className='formfieldcommon'>
                  <label>Expertise</label>
                  <input type="text" id="expertise" placeholder='expertise' readOnly />
                </div>


              </div>
              <div className='vl_dsh_one_half'>
                <div className='formfieldcommon openedit'>
                  <label>Your First Name</label>
                  <input type="text" id="fname" placeholder='Insert Your First Name' readOnly />
                </div>

                <div className='formfieldcommon openedit'>
                  <label>Your Last Name</label>
                  <input type="text" id="lname" placeholder='Insert Your Last Name' readOnly />
                </div>



                <div className='formfieldcommon'>
                  <label>Role</label>
                  <input type="text" id="role" placeholder='Role' readOnly />
                </div>
                <div className='formfieldcommon'>
                  <label>Your Skills</label>
                  <input type="text" id="skills" placeholder='View Your Position' readOnly />
                </div>

                <div className='vl_dsh_btn_holder text_right nodisplay profile_update_btn'>
                  <button onClick={updateProfile}>Update</button>
                </div>
              </div>
            </div>

          </div>

        </section>

      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
    </div>
  )
}
